'use client'

import envs from '@envs'

import storage from '@/utils/browser/storage'

import formattersAuth from './authorization/formatters'
import { setAttribute } from '@/utils/newRelic'

const TOKEN_KEY = 'auth-token'

export const httpRequest = async ({ options = {}, url }) => {
  const authToken = await _getAuthToken()

  setAttribute({
    getAuthToken: authToken
  })

  const fetchResponse = await fetch(`${envs.API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      ['Authorization']: `Bearer ${authToken?.auth?.accessToken || authToken?.accessToken}`,
      ['Content-Type']: 'application/json'
    }
  }).then((res) => res)

  if (!fetchResponse.ok) {
    return {
      error: {
        code: fetchResponse.status,
        message: fetchResponse.statusText
      }
    }
  }

  const responseData = await fetchResponse.json()

  // This will check if the response have a new auth token,
  // this is common when there are levels of access
  // on the api, like data that can be requested without a
  // lead uuid and data that need one.
  const responseHaveAuth = responseData?.auth?.access_token

  if (responseHaveAuth) {
    await setAuthToken(formattersAuth.auth(responseData.auth))
  }

  return responseData
}

// const _checkTokenIsValid = (tokenFromSession) => {
//   if (!tokenFromSession) return false

//   const dateNow = new Date()
//   const tokenExpirationDate = new Date(tokenFromSession.auth.expiresIn * 1000)

//   return dateNow <= tokenExpirationDate
// }

const _getAuthToken = async () => {
  const tokenFromSession = storage.session.getItem(TOKEN_KEY)

  if (!tokenFromSession) return false

  return tokenFromSession
}

export const setAuthToken = async (responseData) => {
  storage.session.setItem(TOKEN_KEY, {
    auth: responseData.auth
  })
}
